import React from 'react';
const FormContext = React.createContext({
  inputId: null,
  feedbackId: null,
  inverted: false,
  errors: {},
  validateInput: null,
  mobileSquareBorders: false,
  defaultValues: {},
  reactBeautifulDnd: undefined
});
export default FormContext;